import {useMemo} from "react";
import {Area, Line} from "recharts";
import {BaseChart, ChartComponent} from "./BaseChart";
import {TimeSeriesDataProps} from "../../../types/timeSeriesDataProps";
import {FieldResult} from "../../../types/domain/fieldResult";
import {useMeasureSystemUtils} from "../../../hooks/measureSystemUtilsHooks";
import {MeasureSystemUtils} from "../../../types/domain/measureSystemUtils";
import {useTranslation} from "react-i18next";
import dayjs from "dayjs";
export interface ActualEvapotranspirationChartDataProps {
    actualEvapotranspiration: number;
    actualTranspiration: number;
}

export const ActualEvapotranspirationChart: ChartComponent = ({data}) => {
    const {t} = useTranslation();
    const msUtils = useMeasureSystemUtils();
    const chartData = useMemo(() => data.map((d) => mapFieldResultsToChartData(d, msUtils)), [data, msUtils]);

    return (
        <BaseChart
            title={t("insights.charts.actual_evapotranspiration.title")}
            yLabel={`${msUtils.getRainfallUnits()}/${t("insights.charts.actual_evapotranspiration.day")}`}
            data={chartData}
            helpPopoverTranslationKey="help.popover.fields.actual_evapotranspiration"
        >
            <Area
                type="monotone"
                dataKey="actualTranspiration"
                name={t("insights.charts.actual_evapotranspiration.area_name")}
                unit={`${msUtils.getRainfallUnits()}/${t("insights.charts.actual_evapotranspiration.day")}`}
                yAxisId="left"
                stroke="#41B6C4"
                fill="#EDF8B1"
                strokeWidth={2}
                isAnimationActive={false}
            />
            <Line
                type="monotone"
                dataKey="actualEvapotranspiration"
                name={t("insights.charts.actual_evapotranspiration.line_name")}
                unit={`${msUtils.getRainfallUnits()}/${t("insights.charts.actual_evapotranspiration.day")}`}
                yAxisId="left"
                stroke="#5161C1"
                strokeWidth={2}
                dot={false}
                isAnimationActive={false}
            />
        </BaseChart>
    );
};

const mapFieldResultsToChartData = (r: FieldResult, msUtils: MeasureSystemUtils): DataProps => ({
    date: dayjs(r.date).toDate(),
    actualEvapotranspiration: msUtils.getRainfall(r.aggregatedProps.actual_evapotranspiration),
    actualTranspiration: msUtils.getRainfall(r.aggregatedProps.actual_transpiration),
});

export interface DataProps extends TimeSeriesDataProps {
    actualEvapotranspiration: number;
    actualTranspiration: number;
}
